/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Group from 'material/group/group';
import Icon from 'material/graphic/icon/icon';
import DatePicker from 'material/datepicker/datepicker';
// utils
import zeroPadding from 'utils/zeroPadding';
import getLastTwoDigit from 'utils/getLastTwoDigit';
// styles
import injectSheet from 'react-jss';
import styles from 'material/dropdowns/daypickerdropdown/daypickerdropdown_styles';



/* ========== ~~~~~~~~~~ DROP FILTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Daypickerdropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
    }
    componentDidMount() {
        return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentWillUnmount() {
        return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    handleOutsideClick = (e) =>{
        // ignore clicks on the component itself
        if (!this.node.contains(e.target) && this.state.active) {
            this.hideMenu()
        }
    };
    handleDayClick = (day) => {
        this.props.selectDay(`${zeroPadding(day.getFullYear(), 2)}-${zeroPadding(day.getMonth() + 1, 2)}-${zeroPadding(day.getDate(), 2)}`);
        this.hideMenu();
    };
    showMenu = () => this.setState({ active: true });
    hideMenu = () => this.setState({ active: false });
    
    handleClick = () => this.state.active ? this.hideMenu() : this.showMenu();
    renderDay = (selectedDay) => {
        //let { selectedDay } = this.state;
        return  selectedDay ? `${zeroPadding(selectedDay.getMonth() + 1, 2)}/${zeroPadding(selectedDay.getDate(), 2)}/${getLastTwoDigit(selectedDay.getFullYear())}` : `Select a day`;
    };
    render() {
        let { active } = this.state;
        return (
            <div className={`daypickerdropdown ${this.props.classes.daypickerdropdown} filter`} ref={node => {this.node=node;}}>
                <div className={`placeholder active-${active}`} onClick={this.handleClick}><span>{this.renderDay(new Date(`${this.props.selectedDay}T00:00:00-05:00`))}</span><Icon name={`sort-down`}/></div>
                <Group name={`dropdown active-${active}`}>
                    <DatePicker selectedDay={new Date(`${this.props.selectedDay}T00:00:00-05:00`)} handleRangeSelect={this.handleDayClick} disabledDays={this.props.disabledDates} type={'day'} numberOfMonths={1}/>
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Daypickerdropdown);